import { PayloadAction } from 'tabs/topQuestions/types/GenericTypes'
import { UnknownQuestionType } from 'tabs/nlp/components/unansweredQuestions/types'


export type SelectedQuestionType = 'all' | UnknownQuestionType

export type TopQuestionsFilter = {
  query?: string,
  type?: UnknownQuestionType
}

export type TopQuestionsSearchSliceState = {
  filter: TopQuestionsFilter
}
export const UPDATE_TOP_QUESTIONS_SEARCH = 'topQuestionsSearch/UPDATE_TOP_QUESTIONS_SEARCH'

export type UpdateTopQuestionsSearch = PayloadAction<typeof UPDATE_TOP_QUESTIONS_SEARCH, Partial<TopQuestionsFilter>>

export type TopQuestionsFilterActions = UpdateTopQuestionsSearch
